// extracted by mini-css-extract-plugin
export var button = "contact-module--button--fZNV3";
export var icon = "contact-module--icon--REI+q";
export var image = "contact-module--image--IVMws";
export var left = "contact-module--left--Pd0wa";
export var right = "contact-module--right--SH4KC";
export var section = "contact-module--section--EwgWg";
export var show = "contact-module--show--UCUSh";